<template>
  <div class="fab-custom" @click="goToGoodPage()">
    <label v-if="hasQuestions">Rapport mission</label>

    <label v-else>
      <template v-if="typeMission === 'reservation'">
        Créer un <strong v-if="hasCoupons">autre</strong> BL
      </template>

      <template v-else>
        Créer une <strong v-if="hasCoupons">autre</strong>
        lettre de voiture
      </template>
    </label>
  </div>
</template>

<script>
export default {
  name: 'NewRentalCoupon',

  props: {
    typeMission: String,
    hasCoupons: Boolean,
    hasQuestions: Boolean,
  },

  methods: {
    goToGoodPage() {
      const toAdd = this.hasQuestions ? 'report' : 'bonLocation/create';
      const { path } = this.$route;

      if (path.endsWith(toAdd)) return;

      this.$router.push({
        path: `${path.endsWith('/') ? path : path + '/'}${toAdd}`,
        query: {}, // Remove query params
      });
    },
  },
};
</script>
